<form #AnexosForm="ngForm">
    <app-custom-modal #modal [title]="'Anexos'" [subtitle]="''" (onCloseClick)="modal.close()" (onSaveClick)="save()"
        [saveLabel]="'Atualizar →'" [saveDisabled]="saving">
        <div class="container">
            <visualizar-anexos-consulta [anexos]="consulta.anexos" [pacienteId]="consulta.pacienteId"
                [idConsulta]="consulta.id" [isEdit]="true" [tipoUsuario]="tipoUsuario" (onFileInsert)="addFile($event)"
                (onFileRemove)="removeFile($event)"></visualizar-anexos-consulta>
        </div>
    </app-custom-modal>
</form>